import { CSSProperties } from "react";
import { clsx, styx } from "modules/Utils";
import Colors from "modules/Colors";
import Icon from "elements/Icon";

interface UpgradeToProLabelProps {
    className: string;
    style?: CSSProperties;
    color?: string | undefined | "PURPLE" | "YELLOW";
    label?: string;
    margin?: string;
    iconBeforeLabel?: React.ReactNode | undefined | false;
    iconAfterLabel?: React.ReactNode | undefined | false;
    isGemIcon?: boolean;
}

const UpgradeToProLabel = ({
    className,
    style,
    color = "PURPLE",
    label,
    iconBeforeLabel = null,
    iconAfterLabel = null,
    margin,
    isGemIcon = true
}: UpgradeToProLabelProps) => {
    const getBackgroundColor = () => {
        if(style?.backgroundColor) {
            return style.backgroundColor;
        }
        switch (color) {
            case 'PURPLE':
                return Colors.purpleBackground;
            case 'YELLOW':
                return Colors.yellowBackground;
            default:
                return color;
        }
    }

    const getColor = () => {
        if(style?.color) {
            return style.color;
        }
        switch (color) {
            case 'PURPLE':
                return Colors.purple;
            case 'YELLOW':
                return Colors.yellowLabel;
            default:
                return color;
        }
    }

    return (
        <div
            className={clsx("upgradeToProLabelContainer", className)}
            style={styx(
                sty.upgradeToProLabelContainer,
                {
                    margin: margin,
                    backgroundColor: getBackgroundColor(),
                },
                style
            )}
        >
            {isGemIcon &&
                <Icon
                    className="upgradeToProLabelIcon"
                    icon="gem"
                    color={getColor()}
                    size={22}
                />
            }
            {iconBeforeLabel}
            <div style={{ color: getColor() }}>
                {label}
            </div>
            {iconAfterLabel}
        </div>
    );
};

const sty: Record<string, CSSProperties> = {
    upgradeToProLabelContainer: {
        gap: 12,
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        opacity: 88,
        paddingTop: 8,
        paddingBottom: 8,
        paddingLeft: 16,
        paddingRight: 16,
        borderRadius: 100,
        borderWidth: 1,
        borderStyle: "solid",
        borderColor: "transparent",
        width: "fit-content",
    }
}

export default UpgradeToProLabel;
